export default {
  badge: 'Bricka',
  open: 'Öppna',
  close: 'Stäng',
  dismiss: 'Avvisa',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Avbryt',
  },
  dataIterator: {
    noResultsText: 'Hittade inga poster',
    loadingText: 'Laddar data...',
  },
  dataTable: {
    itemsPerPageText: 'Rader per sida:',
    ariaLabel: {
      sortDescending: 'Fallande sortering.',
      sortAscending: 'Stigande sortering.',
      sortNone: 'Osorterat.',
      activateNone: 'Aktivera för att ta bort sortering.',
      activateDescending: 'Aktivera för att sortera fallande.',
      activateAscending: 'Aktivera för att sortera stigande.',
    },
    sortBy: 'Sortera efter',
  },
  dataFooter: {
    itemsPerPageText: 'Objekt per sida:',
    itemsPerPageAll: 'Alla',
    nextPage: 'Nästa sida',
    prevPage: 'Föregående sida',
    firstPage: 'Första sidan',
    lastPage: 'Sista sidan',
    pageText: '{0}-{1} av {2}',
  },
  dateRangeInput: {
    divider: 'till',
  },
  datePicker: {
    itemsSelected: '{0} valda',
    range: {
      title: 'Välj datum',
      header: 'Välj datum',
    },
    title: 'Välj datum',
    header: 'Välj datum',
    input: {
      placeholder: 'Välj datum',
    },
  },
  noDataText: 'Ingen data tillgänglig',
  carousel: {
    prev: 'Föregående vy',
    next: 'Nästa vy',
    ariaLabel: {
      delimiter: 'Karusellvy {0} av {1}',
    },
  },
  calendar: {
    moreEvents: '{0} fler',
    today: 'Idag',
  },
  input: {
    clear: 'Rensa {0}',
    prependAction: '{0} föregående åtgärd',
    appendAction: '{0} efterföljande åtgärd',
    otp: 'Vänligen ange OTP-tecken {0}',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1})',
  },
  fileUpload: {
    title: 'Dra och släpp filer här',
    divider: 'eller',
    browse: 'Bläddra bland filer',
  },
  timePicker: {
    am: 'FM',
    pm: 'EM',
    title: 'Välj tid',
  },
  pagination: {
    ariaLabel: {
      root: 'Paginering',
      next: 'Nästa sida',
      previous: 'Föregående sida',
      page: 'Gå till sida {0}',
      currentPage: 'Aktuell sida, sida {0}',
      first: 'Första sidan',
      last: 'Sista sidan',
    },
  },
  stepper: {
    next: 'Next',
    prev: 'Previous',
  },
  rating: {
    ariaLabel: {
      item: 'Betyg {0} av {1}',
    },
  },
  loading: 'Laddar...',
  infiniteScroll: {
    loadMore: 'Ladda fler',
    empty: 'Inga fler',
  },
  rules: {
    required: 'Detta fält är obligatoriskt',
    email: 'Ange en giltig e-postadress',
    number: 'Detta fält kan bara innehålla siffror',
    integer: 'Detta fält kan bara innehålla heltal',
    capital: 'Detta fält kan bara innehålla stora bokstäver',
    maxLength: 'Du måste ange högst {0} tecken',
    minLength: 'Du måste ange minst {0} tecken',
    strictLength: 'Längden på det angivna fältet är ogiltig',
    exclude: 'Tecknet {0} är inte tillåtet',
    notEmpty: 'Välj minst ett värde',
    pattern: 'Ogiltigt format',
  },
}
